import { render } from "./PayLogin.vue?vue&type=template&id=406534d0"
import script from "./PayLogin.vue?vue&type=script&lang=js"
export * from "./PayLogin.vue?vue&type=script&lang=js"

import "./PayLogin.vue?vue&type=style&index=0&id=406534d0&lang=less"

import exportComponent from "/Users/kk/ulu/dev/UstoreWebPayPC/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__